module.exports = __webpack_public_path__ + "img/6_117.c50456a5.png";